module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_8004.9a6df47a.png";